__turbopack_context__.v({
  "btn": "styles-module-scss-module__EmjM_q__btn",
  "content": "styles-module-scss-module__EmjM_q__content",
  "root": "styles-module-scss-module__EmjM_q__root",
});
